import React from 'react';
import PropTypes from 'prop-types';

import format from '../../../../../utils/format';
import YesNoUnknown from '../../../YesNoUnknown';
import { ViewerPrimaryColorUserStyle } from '../../../../UserCustomization';

export function SitePropertyOverview({
  basicInfo,
  additionalDetails,
}) {
  const { location } = basicInfo;
  const { about } = additionalDetails;
  const cityLimitsConditional =
  location.inCityLimits !== null && Number.isInteger(location.inCityLimits);

  function getWebsiteUrl(website) {
    return (typeof website === 'string' && website.match(/^http/)) ? website : `http://${website}`;
  }

  return (
    <ul>
      {
        basicInfo.acres &&
        <li><strong>Available Acres:</strong> {format(basicInfo.acres)}</li>
      }
      {
        about.topography &&
        <li><strong>Topography:</strong> {about.topography}</li>
      }
      {
        about.zoning &&
        about.zoning.length > 0 &&
        <li><strong>Zoning:</strong> {about.zoning.join(', ')}</li>
      }
      {
        !!additionalDetails.about.adjacentAvailableAcres &&
        <li>
          <strong>Adjacent Available Acres: </strong>
          {format(additionalDetails.about.adjacentAvailableAcres)}
        </li>
      }
      {
        additionalDetails.setting &&
        <li><strong>Setting:</strong> {additionalDetails.setting}</li>
      }
      {
        !!cityLimitsConditional &&
        <li>
          <strong>Within City Limits: </strong>
          <YesNoUnknown value={location.inCityLimits} />
        </li>
      }
      {
        about.additionalDetailsUrl &&
        <li>
          <strong>Additional Details: </strong>
          <ViewerPrimaryColorUserStyle domStyle="color">
            <a
              target="_blank" rel="noopener noreferrer"
              href={getWebsiteUrl(about.additionalDetailsUrl)}
            >
              {about.additionalDetailsUrl}
            </a>
          </ViewerPrimaryColorUserStyle>
        </li>
      }
    </ul>
  );
}

SitePropertyOverview.propTypes = {
  additionalDetails: PropTypes.object.isRequired,
  basicInfo: PropTypes.object.isRequired,
};

export default SitePropertyOverview;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailOverview/OverviewSections/PropertyTypes/SitePropertyOverview.js